document.querySelectorAll('[data-component-video]').forEach((component) => {
  const video = component.querySelector('video');
  const toggle = component.querySelector('[data-component-video-toggle]');

  if (!video || !toggle) return;

  const updateToggle = () => {
    const isPaused = video.paused;
    toggle.classList.toggle('is-paused', isPaused);
    toggle.setAttribute('aria-label', isPaused ? 'Video abspielen' : 'Video pausieren');
  };

  toggle.addEventListener('click', () => {
    if (video.paused) {
      video.play().catch(updateToggle);
      return;
    }

    video.pause();
  });

  video.addEventListener('play', updateToggle);
  video.addEventListener('pause', updateToggle);
  video.addEventListener('ended', updateToggle);
  updateToggle();
});
